import { FieldErrors } from "../errors/FieldErrors.js";

export type CmtsFieldErrorsProps = {
  readonly fieldName: string;
  readonly errors?: Record<string, string[]> | null | undefined;
  readonly aliases?: readonly string[] | undefined;
  readonly entityType?: string | undefined;
};

const DEFAULT_ALIASES: Readonly<Record<string, readonly string[]>> = {
  sourceId: ["complaintSourceId", "source"],
  typeId: ["complaintTypeId", "type"],
  categoryId: ["complaintCategoryId", "category"],
  subcategoryId: ["complaintSubcategoryId", "subcategory"],
  severityId: ["severity"],
  priorityId: ["priority"],
  referenceTypeId: ["typeId", "referenceType"],
  parentCategoryId: ["categoryId", "parentId"],
  ownerId: ["owner"],
  assigneeId: ["assignee"],
  verifierId: ["verifier"],
  dueDate: ["targetDate", "plannedDate"],
};

export function aliasesForCmtsField(fieldName: string, explicitAliases: readonly string[] = []): readonly string[] {
  const defaults = DEFAULT_ALIASES[fieldName] ?? [];
  return [...new Set([...defaults, ...explicitAliases])];
}

export function CmtsFieldErrors(props: CmtsFieldErrorsProps) {
  return <FieldErrors fieldName={props.fieldName} errors={props.errors ?? {}} aliases={aliasesForCmtsField(props.fieldName, props.aliases)} />;
}
